import React from "react";
import styled from "styled-components";
import { ButtonRound } from "components/generic/kit";
import { Field } from "formik";

export default props => (
  <Field
    name={props.name}
    render={props => {
      return (
        <Upload
          {...props}
          value=""
          onChange={e => {
            const file = e.target.files[0];

            props.form.setValues({
              ...props.form.values,
              [props.field.name]: file
            });
          }}
        />
      );
    }}
  />
);

const Upload = props => {
  const error = props.form.errors[props.field.name];
  const touched = props.form.touched[props.field.name];

  return (
    <React.Fragment>
      <label>
        <ButtonRound bordered>Upload resume</ButtonRound>
        <UploadWrap {...props.field} {...props} type="file" />
      </label>
      <div className="mt2 absolute left-0 bottom-0">
        {error && touched && <Error>{error}</Error>}
      </div>
    </React.Fragment>
  );
};

const UploadWrap = styled.input`
  appearance: none;
  outline: 0;
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
`;

const Error = styled.div`
  color: #f76367;
  margin-bottom: -15px;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/components/File/index.js